var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12521 14.6258L1.12463 14.6263L0.896955 14.8416L0.781649 14.9506L0.896955 15.0596L1.12463 15.2748L1.12521 15.2754L8.10735 21.8066L8.10783 21.8071L8.32792 22.0112L8.43499 22.1105L8.53712 22.0061L8.95833 21.5756L9.06608 21.4655L8.95311 21.3607L8.73346 21.157L8.73302 21.1566L2.57166 15.3975H17.5257H17.8292H17.9792V15.2475V14.6537V14.5037H17.8292H17.5257H2.57149L8.72923 8.74456L8.72969 8.74412L8.94932 8.54045L9.06178 8.43616L8.95501 8.32605L8.5376 7.89558L8.43548 7.79027L8.32792 7.89001L8.10782 8.09411L8.10735 8.09456L1.12521 14.6258Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.51dfca0acf51361fd6012c5d39f2b2ae.svg";
export { ForwardRef as ReactComponent };